import script from "./color-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./color-button.vue?vue&type=script&setup=true&lang=ts"

import "./color-button.vue?vue&type=style&index=0&id=75622946&lang=scss"

const __exports__ = script;

export default __exports__